module.exports = __webpack_public_path__ + "img/补发.3bf07f81.svg";